// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Stack } from '@mui/material';

// assets
import Google from '../../assets/icons/google.svg';
import Microsoft from '../../assets/icons/microsoft.svg';

import { StyledButton } from './SocialIcons.styles';


const SocialIcons = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  const googleHandler = async () => {
      window.location.href = `${process.env.REACT_APP_API_BASE_URL}api/v1/google`
  };

  const microsoftHandler = async () => {
    window.location.href = `${process.env.REACT_APP_API_BASE_URL}api/v1/microsoft`
  };

  return (
    <Stack
      direction="row"
      spacing={matchDownSM ? 1 : 2}
      justifyContent={matchDownSM ? 'space-around' : 'space-between'}
      sx={{ '& .MuiButton-startIcon': { mr: matchDownSM ? 0 : 1, ml: matchDownSM ? 0 : -0.5 } }}
      className={'customButtom'}
    >
      <StyledButton
        variant="outlined"
        color="primary"
        style={{width:'60%',margin:'auto',borderRadius:20}}
        // fullWidth={!matchDownSM}
        startIcon={<img src={Google} alt="Google" />}
        onClick={googleHandler}
      >
        {!matchDownSM && 'Google'}
      </StyledButton>

      {/* <StyledButton
        variant="outlined"
        color="primary"
        fullWidth={!matchDownSM}
        startIcon={<img src={Microsoft} alt="Microsoft" />}
        onClick={microsoftHandler}
      >
        {!matchDownSM && 'Microsoft'}
      </StyledButton> */}
    </Stack>
  );
};

export default SocialIcons;
